import MuiCard from '@mui/material/Card';
import type { ComponentProps } from 'react';

export const Card = (props: ComponentProps<typeof MuiCard>) => {
  return <MuiCard sx={{ borderRadius: '12px' }} {...props} />;
};
